import { signalStore, withState, withMethods, patchState, withComputed } from '@ngrx/signals';
import { computed, inject } from '@angular/core';
import { AgencyGridService } from './agency-grid.service';
import { AgencyGridViewModel, AgencyGridRowViewModel } from '@program-suite/data-common';

export const AgencyGridStore = signalStore(
  { providedIn: 'root' },
  withState<AgencyGridViewModel & { filterValues: object }>({
    totalCount: <number>0,
    rows: <AgencyGridRowViewModel[]>[],
    filterValues: <object>{},
  }),
  withComputed((state) => ({
    debug: computed(() => ({
      totalCount: state?.totalCount?.(),
      rows: state?.rows?.(),
      filterValues: state?.filterValues?.(),
    })),
  })),
  withMethods((store, agencyGridService = inject(AgencyGridService)) => ({
    setAgencyGrid(agencyGrid: AgencyGridViewModel) {
      patchState(store, {
        totalCount: agencyGrid.totalCount,
        rows: agencyGrid.rows,
      });
    },
    async getAgencyGrid(params: any) {
      const agencyGrid = await agencyGridService.getAgencyGrid(params);
      this.setAgencyGrid(agencyGrid);
    },
    setFilterValues(value: object) {
      patchState(store, {
        filterValues: value,
      });
    },
  })),
);
